/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTIDeepLinkResultParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('deep_link')],
    ['deepLinkBlobId', codecString, 'deep_link_blob_id'],
    ['authToken', codecString, 'auth_token'],
]);
export class LTIDeepLinkResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTIDeepLinkResultParser.decode(input).map(res => new LTIDeepLinkResult(res));
    }
    static unsafeDecode(input) {
        return LTIDeepLinkResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTIDeepLinkResultParser.encode(data);
    }
    static schema() {
        return LTIDeepLinkResultParser.schema();
    }
}
